import React, { useState } from "react";
import { useParams } from "react-router-dom";
import axios from "../../api/axiosinstance";
import { showSuccess, showError } from "../../utils/toastUtils";

function AgreementAcceptPage() {
  const { id } = useParams();

  const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [accepted, setAccepted] = useState(false);

  const handleAccept = async () => {
    if (!checked) {
      return showError("Please accept terms first");
    }

    try {
      setLoading(true);

      const res = await axios.post("/agreements/accept", {
        agreementId: id,
      });

      showSuccess(res.data.message); // ✅ FIXED
      setAccepted(true);
    } catch (err) {
      showError(err.response?.data?.message || "Something went wrong"); // ✅ FIXED
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "40px", textAlign: "center" }}>
      <h2>Service Agreement</h2>

      {!accepted ? (
        <>
          <p>Please read and accept the agreement to continue.</p>

          <div style={{ marginTop: "20px" }}>
            <label>
              <input
                type="checkbox"
                checked={checked}
                onChange={(e) => setChecked(e.target.checked)}
              />{" "}
              I agree to the terms & conditions
            </label>
          </div>

          <button
            onClick={handleAccept}
            disabled={loading}
            style={{
              marginTop: "20px",
              padding: "10px 25px",
              background: "#000",
              color: "#fff",
              border: "2px solid orange",
              cursor: "pointer",
            }}
          >
            {loading ? "Processing..." : "Accept Agreement"}
          </button>
        </>
      ) : (
        <h3 style={{ color: "green" }}>✅ Agreement Accepted Successfully</h3>
      )}
    </div>
  );
}

export default AgreementAcceptPage;
